import { useState } from "react";
import { benefits } from "@/mocks/chiagua";

export default function MemberCta() {
  const [toast, setToast] = useState(false);

  const showDemo = () => {
    setToast(true);
    window.setTimeout(() => setToast(false), 2600);
  };

  return (
    <section id="join" className="relative overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-primary-500/30 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 -right-16 h-72 w-72 rounded-full bg-accent-500/25 blur-3xl"></div>

      <div className="relative mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-200">
            <i className="ri-vip-crown-2-line"></i> 开通即享完整权限
          </p>
          <h2 className="mx-auto mt-5 max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            开通「吃瓜福利会员」，<br className="md:hidden" />
            内部资源与付费内容<span className="text-accent-400">一站全部解锁</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
            一次开通，畅享每日早报、内部资源、独家深度与隐藏内容抢先看，从此不用再为每一口付费瓜单独买单。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((b) => (
            <div key={b.title} className="rounded-2xl border border-background-50/10 bg-background-50/[0.04] p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500/20 text-accent-400">
                <i className={b.icon + " text-xl"}></i>
              </span>
              <h3 className="mt-3 text-sm font-semibold text-background-50 md:text-base">{b.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-300 md:text-sm">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center gap-5 rounded-3xl border border-background-50/10 bg-background-50/[0.06] p-8 text-center md:p-10">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-foreground-200">
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400"></i> 全站隐藏内容
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400"></i> 独家深度整理
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400"></i> 会员抢先查看
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400"></i> 无广告清爽版
            </span>
          </div>
          <div className="flex items-end justify-center gap-1">
            <span className="mb-1 text-sm text-foreground-300">¥</span>
            <span className="font-heading text-5xl font-black text-background-50 md:text-6xl">19</span>
            <span className="mb-1 text-sm text-foreground-300">/ 月</span>
          </div>
          <p className="max-w-xl text-xs text-foreground-400">
            开通即享吃瓜福利会员完整权限，内部资源与付费内容一站解锁。演示环境暂未接入真实支付，点击按钮仅作展示。
          </p>
          <button
            type="button"
            onClick={showDemo}
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-sm font-bold text-background-50 transition-transform hover:scale-[1.03] hover:bg-primary-400"
          >
            <i className="ri-vip-crown-2-fill text-lg"></i>
            立即开通会员
          </button>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2">
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-5 py-3 text-sm text-foreground-800 shadow-lg">
            <i className="ri-information-line text-primary-500"></i>
            演示站暂未接入支付，仅供页面展示
          </div>
        </div>
      )}
    </section>
  );
}